import { createParam } from 'solito'
import { BrandScreen } from './brand-screen'
import { useBrandQuery } from './queries'
import { useBrandOffersQuery } from './queries/use-brand-offers.query'
import { dedupeBrandOfferIds } from './lib/dedupe-brand-offer-ids'

const { useParam } = createParam<{ brand: string }>()

export interface BrandScreenContainerProps {
  draft?: boolean
}

export const BrandScreenContainer = (props: BrandScreenContainerProps) => {
  const [slug] = useParam('brand')
  const { loading, data } = useBrandQuery({
    slug: slug || '',
    draft: !!props.draft,
  })
  const brandId = data?.Brands?.docs?.[0]?.id || ''

  const dedupeIds = dedupeBrandOfferIds(data)

  const {
    loading: brandOffersLoading,
    data: brandOffersData,
    fetchMore,
  } = useBrandOffersQuery({
    variables: {
      brand: brandId,
      dedupeIds,
      page: 1,
      limit: 6,
    },
    skip: !brandId,
  })

  const hasMore =
    (brandOffersData?.fetchOffers?.page || 0) < (brandOffersData?.fetchOffers?.totalPages || 0)

  const handleLoadMore = () => {
    fetchMore({
      variables: {
        page: (brandOffersData?.fetchOffers?.page || 0) + 1,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev
        }
        return {
          fetchOffers: {
            ...fetchMoreResult.fetchOffers,
            docs: [...(prev.fetchOffers?.docs || []), ...(fetchMoreResult.fetchOffers?.docs || [])],
          },
        }
      },
    })
  }

  return (
    <BrandScreen
      loading={loading}
      brand={data?.Brands?.docs[0]}
      offers={brandOffersData?.fetchOffers?.docs || []}
      hasMore={hasMore}
      loadingMore={brandOffersLoading}
      onLoadMore={handleLoadMore}
    />
  )
}
